// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"ff0ee301","527":"84756b69","818":"ed6f8a66","856":"c5c226d2"}[chunkId] + ".chunk.css";
};